import { gql, useMutation } from 'urql';

const UPDATE_SMINEX_CLUB_CLIENT_TICKET_QUERY = gql`
  mutation UpdateSminexClubClientTicket($ticketId: Int!, $input: UpdateSminexClubClientTicketInput) {
    updateSminexClubClientTicket(ticketId: $ticketId, input: $input) {
      id
    }
  }
`;

export interface UpdateSminexClubClientTicketInput {
  review?: string;
  comment?: string;
  sminexClubInvitation?: string;
  sminexClubReconfirmationStatus?: string;
  sminexClubAdditional?: string;
  invitedByManager?: string;
  mobileComment?: string;
  checked?: boolean;
  isSpecial?: boolean;
}

export const useUpdateSminexClubClientTicket = () => {
  const [{ data, error }, executeMutation] = useMutation(UPDATE_SMINEX_CLUB_CLIENT_TICKET_QUERY);

  const updateSminexClubClientTicket = (ticketId: number, input: UpdateSminexClubClientTicketInput) => {
    return executeMutation({ ticketId, input });
  };

  return { data, error, updateSminexClubClientTicket };
};
